import React from 'react'
import t from '../../translations/i18n'
import '../../scss/terminos.scss'

export default function Terminos() {
  return (
    <div className="page-content easybuy-terms-page">
      <div className="container">
        <div className="easybuy-terms-header text-center">
          <span className="easybuy-terms-badge">
            <i className="la la-file-text"></i>
            Términos y condiciones
          </span>

          <h2>{t('terminos.tittle')}</h2>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-9">
            <div className="easybuy-terms-card">
              <div className="easybuy-terms-item">
                <div className="easybuy-terms-icon">
                  <i className="la la-check-circle"></i>
                </div>

                <p>{t('terminos.p_1')}</p>
              </div>

              <div className="easybuy-terms-item">
                <div className="easybuy-terms-icon">
                  <i className="la la-check-circle"></i>
                </div>

                <p>{t('terminos.p_2')}</p>
              </div>

              <div className="easybuy-terms-item">
                <div className="easybuy-terms-icon">
                  <i className="la la-check-circle"></i>
                </div>

                <p>{t('terminos.p_3')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
